import { IFilters } from '@features/General'
import { MeetingStatus, MeetingType } from '@features/Meeting/MeetingAgenda'

export const listFilters = (i18n: any, companyId?: string): IFilters[] => [
    {
        key: 'companies',
        queryKeys: ['guestCompanyId', 'hostCompanyId'],
        title: i18n?.General?.Companies,
        type: 'select',
        labelField: 'name',
        projection: ['_id', 'name', 'logo'],
        hide: !!companyId,
        searchableFields: ['name'],
        logoField: 'logo',
        multiple: true
    },
    {
        key: 'participants',
        modelName: 'contacts',
        title: i18n?.Meeting?.Contacts,
        type: 'select',
        labelField: ['firstname', 'lastname'],
        searchableFields: ['firstname', 'lastname'],
        queryKeys: ['guestIds', 'hostIds', 'guests'],
        projection: ['_id', 'firstname', 'lastname', 'avatar'],
        logoField: 'avatar',
        multiple: true
    },
    {
        key: 'status',
        title: i18n?.General?.Status,
        type: 'select',
        values: MeetingStatus,
        multiple: true
    },
    {
        key: 'meetingDate',
        queryKeys: ['startTime', 'endTime'],
        title: i18n?.Meeting?.Meeting_Date,
        type: 'rangeDate'
    },
    {
        key: 'meetingType',
        title: i18n?.Meeting?.Meeting_Type,
        type: 'select',
        values: MeetingType,
        multiple: true
    }
]
